/* ==========================================================================
   Future Aesthetics — <fa-gallery>
   Vertical thumbnail rail + main stage. Thumbnails scroll independently; the
   stage swaps without a reload. Keyboard arrows move between images.
   ========================================================================== */

(function () {
  'use strict';

  class FaGallery extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-gallery-slide]')];
      this.thumbs = [...this.querySelectorAll('[data-gallery-thumb]')];
      this.rail = this.querySelector('[data-gallery-thumbs]');
      this.index = 0;

      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => this.show(Number(thumb.dataset.galleryThumb)));
      });

      this.querySelector('[data-gallery-prev]')?.addEventListener('click', () => this.step(-1));
      this.querySelector('[data-gallery-next]')?.addEventListener('click', () => this.step(1));

      this.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          event.preventDefault();
          this.step(1);
        } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          event.preventDefault();
          this.step(-1);
        }
      });

      if (this.classList.contains('fa-gallery--zoom')) {
        this.querySelector('.fa-gallery__stage')?.addEventListener('click', (event) => {
          const img = event.target.closest('img[data-full]');
          if (img) this.openZoom(img.dataset.full, img.alt);
        });
      }
    }

    step(direction) {
      this.show(this.index + direction);
    }

    show(next) {
      if (!this.slides.length) return;
      // Wrap so the arrows never dead-end.
      const total = this.slides.length;
      this.index = ((next % total) + total) % total;

      this.slides.forEach((slide, i) => {
        const active = i === this.index;
        slide.classList.toggle('is-active', active);
        slide.toggleAttribute('aria-hidden', !active);
      });

      this.thumbs.forEach((thumb, i) => thumb.classList.toggle('is-active', i === this.index));

      const activeThumb = this.thumbs[this.index];
      if (activeThumb && this.rail) {
        activeThumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      }
    }

    openZoom(src, alt) {
      const overlay = document.createElement('div');
      overlay.className = 'fa-gallery__zoom';
      overlay.innerHTML = `
        <button type="button" class="fa-gallery__zoom-close" aria-label="Close">&times;</button>
        <img src="${src}" alt="${alt || ''}">`;

      const close = () => {
        overlay.remove();
        document.body.style.overflow = '';
        window.faLenis?.start();
      };

      overlay.addEventListener('click', (event) => {
        if (event.target === overlay || event.target.closest('.fa-gallery__zoom-close')) close();
      });
      document.addEventListener('keydown', function onKey(e) {
        if (e.key === 'Escape') {
          close();
          document.removeEventListener('keydown', onKey);
        }
      });

      document.body.appendChild(overlay);
      document.body.style.overflow = 'hidden';
      window.faLenis?.stop();
    }
  }

  if (!customElements.get('fa-gallery')) customElements.define('fa-gallery', FaGallery);
})();
